import React from 'react'; 
import WithConsumer from '../../context/WithConsumer';
import PageBlock from './PageBlock';
import Footer from './../global/Footer';

const Page = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
     
    if (post) {
	    
	    
	    let pageClass = 'c-page c-page--' + post.slug;
	        	
    	if (post.block) {
			
		    const blocks 		= post.block; 
			
			if (context.appError){
			
				return null; 
			
			} else {
		
					
				let pageBlocks = blocks.map(function(block,i){
					return <PageBlock key={i} index={i}></PageBlock>
				})
				
				return (
					<>
							
						<div className={pageClass}>
							{blocks.length > 0 &&
								<div className="c-page__inner">
									{pageBlocks}	
								</div>
							}
							<Footer post={post}></Footer>
						</div>
						
					</>
				)
					
			}
		} else {
			return null;
		}
	} else {
		return null;
	}
};
export default WithConsumer(Page);